import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Page from "../../components/layout/Page";
import { Button } from "../../components/widgets/index";
import * as supportActions from "../../redux/actions/support";
import Permissions from "../../permissions";
import SupportIssueForm from "../../components/support/SupportIssueForm";

const mapStateToProps = state => ({
  zendesk_tickets: state.support.zendesk_tickets,
});

const mapDispatchToProps = dispatch => {
  return {
    supportActions: bindActionCreators(supportActions, dispatch),
  };
};

class SupportIssueCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticket: {
        subject: "",
        comment: "",
        address: "",
      },
      errors: {},
    };
  }

  handleFieldOnChange = (fieldName, value) => {
    this.setState({
      ticket: {
        ...this.state.ticket,
        [fieldName]: value,
      },
    });
  };

  validateTicket = () => {
    let errors = {};
    if (!this.state.ticket.address) {
      errors.address = "You must enter an address";
    }

    if (!this.state.ticket.subject) {
      errors.subject = "You must enter a surname";
    }

    if (!this.state.ticket.comment) {
      errors.comment = "You must enter a comment.";
    }

    return errors;
  };

  hasErrors = errors => {
    if (errors.address || errors.subject || errors.comment) {
      return true;
    }

    return false;
  };

  saveTicket = () => {
    const errors = this.validateTicket();
    const hasErrors = this.hasErrors(errors);

    if (hasErrors) {
      this.setState({
        errors: errors,
      });
    } else {
      this.setState({
        errors: {},
      });
      this.props.supportActions.createZendeskTicket(this.state.ticket);
      this.props.history.push("/support-issues");
    }
  };

  render() {
    return (
      <Page permission={Permissions.fleet.node.any}>
        <Page.Header title="Create Support Ticket">
          <Page.Header.Actions>
            <Button
              id="my-reposit-cancel-edit-user"
              type="secondary"
              icon="times"
              to="/support-issues"
            >
              Cancel
            </Button>
            <Button
              id="my-reposit-save-user"
              type="primary"
              icon="check"
              onClick={this.saveTicket}
              loading={this.props.savingUser}
            >
              Save
            </Button>
          </Page.Header.Actions>
        </Page.Header>
        <Page.Content>
          <SupportIssueForm
            comment={this.state.comment}
            address={this.state.address}
            subject={this.state.subject}
            handleFieldOnChange={this.handleFieldOnChange}
            errors={this.state.errors}
          />
        </Page.Content>
      </Page>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SupportIssueCreate);
